<template>
  <div id="goods-bottom">
    <div class="goods-bottom" :style="{height: tabHeight+'px'}">
      <div class="cart" @click="goodsBottomClick(0)">
        <img class="image" :src="cartCount<=0?cartImg_n:cartImg_s" s />
        <div class="number" v-show="cartCount>0">{{(cartCount-99>0)?'99+':cartCount}}</div>
        <div class="title">购物车</div>
      </div>
      <div class="line"></div>
      <div class="customer" @click="serverClick">
        <div class="image"></div>
        <div class="title">客服</div>
      </div>
      <div class="btnbox">
        <div class="addbtn" @click="goodsBottomClick(1)">加入购物车</div>
        <div class="buybtn" @click="goodsBottomClick(2)">立即购买</div>
      </div>

    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  props: {
    phone: '',
    cartCount: 0
  },
  data () {
    return {
      cartImg_n: require('../images/icon-cart-n.png'),
      cartImg_s: require('../images/icon-cart-s.png'),
      tabHeight: 65
    }
  },
  methods: {
    serverClick () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
      // if (parseInt(this.$route.query.isApp) === 1 ||
      // parseInt(localStorage.getItem('isApp')) === 1 ||
      // parseInt(this.$route.query.isApp) === 2 ||
      // parseInt(localStorage.getItem('isApp')) === 2) {
      //   // if (parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      //   //   if (this.$parent.isLogin == 0) {
      //   //     this.$parent.uaCheck()
      //   //   }
      //   // }
      //   if (this.utils.isIphone()) {
      //     window.webkit.messageHandlers.callService.postMessage('4001919119')
      //   } else {
      //     window.zxzx.callService('4001919119')
      //   }
      // } else {
      //   window.location.href = 'tel:4001919119'
      // }
    },
    goodsBottomClick: function (index) {
      // 0 购物车 1加入购物车 2 立即购买
      this.$emit('click', index)
    },
    androidTabHeight: function (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 80
        } else {
          this.tabHeight = 80
        }
      } else {
        this.tabHeight = this.tabHeight + parseInt(value)
      }
    }
  },
  mounted () {
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style scoped>
.goods-bottom {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 65px;
  background-color: #ffffff;
  border-top: solid #eeeeee 1px;
  box-sizing: border-box;
  z-index: 1000;
}
.goods-bottom .cart {
  position: absolute;
  top: -9px;
  width: 70px;
  height: 75px;
  /*background-color: lightgrey;*/
}
.goods-bottom .cart .image {
  position: absolute;
  top: 0px;
  left: 15px;
  width: 40px;
  height: 40px;
  background-image: url("../images/icon-cart-n.png");
  background-size: cover;
}
.goods-bottom .cart .number {
  position: absolute;
  top: -5px;
  left: 38px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  background-color: #ffa104;
  border-radius: 10px;
}
.goods-bottom .cart .title {
  position: absolute;
  top: 43px;
  left: 10px;
  width: 50px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000000;
  text-align: center;
}
.goods-bottom .line {
  position: absolute;
  top: 13px;
  left: 70px;
  width: 1px;
  height: 39px;
  background-color: #eeeeee;
}
.goods-bottom .customer {
  position: absolute;
  top: 0px;
  left: 70px;
  width: 56px;
  height: 65px;
}
.goods-bottom .customer .image {
  position: absolute;
  top: 15px;
  left: 18px;
  width: 20px;
  height: 20px;
  background-image: url("../images/icon-cus.png");
  background-size: cover;
}
.goods-bottom .customer .title {
  position: absolute;
  top: 35px;
  left: 0px;
  width: 56px;
  height: 20px;
  line-height: 20px;
  font-size: 11px;
  color: #808080;
  text-align: center;
}
.goods-bottom .btnbox {
  height: 65px;
  width: calc(100% - 130px);
  float: right;
  font-size: 0;
  line-height: 73px;
  padding-right: 15px;
}
.goods-bottom .btnbox .buybtn {
  display: inline-block;
  width: 50%;
  height: 35px;
  line-height: 35px;
  background-color: #c41335;
  border-radius: 0 4px 4px 0;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
}
.goods-bottom .btnbox .addbtn {
  display: inline-block;
  width: 50%;
  height: 35px;
  line-height: 35px;
  background-color: #900e27;
  border-radius: 4px 0 0 4px;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
}
/* <div class="btnbox">
        <div class="addbtn" @click="goodsBottomClick(1)">加入购物车</div>
        <div class="buybtn" @click="goodsBottomClick(2)">立即购买</div>
      </div> */
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/goods-bottom.vue